import Dashboardpic from '../assets/img/dashboard.png';
import Circle from '../assets/img/circle.png';
import Rectangle from '../assets/img/rect.png';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect, useRef } from 'react';

const Features = ({ pageOffset }) => {

    const cParallax = useRef({
        x: 0,
        y: 0
    });

    const rParallax = useRef({
        x: 0,
        y: 0
    });

    useEffect(() => {
        AOS.init({ duration: 2000 });
    });

    useEffect(() => {
        let valc_x = (pageOffset * 6) / 100;
        let valc_y = (pageOffset * 2) / 100;
        let val_x = (pageOffset * -6) / 100;
        let val_y = (pageOffset * 10) / 100;
        cParallax.current.x = valc_x;
        cParallax.current.y = valc_y;
        rParallax.current.x = val_x;
        rParallax.current.y = val_y;
    }, [pageOffset]);

    return (
        <section className="Feature" id="Features">
            <div className='dashboard__demo'>
                <div data-aos="fade-left">
                    <img src={Dashboardpic} className="demo" alt="dashboard" />
                </div>
                <img src={Circle} className="circle" style={{transform: `translate3d(${cParallax.current.x}px, ${cParallax.current.y}px, 0px`}} alt="circle" />
                <img src={Rectangle} className="rectangle" style={{transform: `translate3d(${rParallax.current.x}px, ${rParallax.current.y}px, 0px`}} alt="rectangle" />
            </div>
            <h2>Platform Features</h2>
            <div className='features__item'>
                <div data-aos="zoom-in">
                    <span>+</span>
                    <h3>Platform Fees</h3>
                    <p>
                        Listing events, minting NFT tickets and selling them on the LadscatchNFT platform is always 100% free for artists and event organisers. Thanks to CARDANO’s blockchain architecture, gas fees for high-volume NFT minting are extremely low. Furthermore, we don’t charge sellers a platform fee.
                        <br/>
                        — Buyers - By default, buyers pay a 7% fee on any purchase. This is reduced for buyers who hold $LDT tokens.
                        <br />
                        — Sellers -There are no fees for selling NFT tickets or other assets on our platform.
                    </p>
                </div>
                <div data-aos="zoom-in" data-aos-delay="200">
                    <span>+</span>
                    <h3>NFT Marketplace</h3>
                    <p>
                        Our all-encompassing marketplace allows people to mint and sell NFT tickets and collectibles and perform airdrops all in one place. We're also fostering a healthy secondary market where buyers and sellers can transact all types of CARDANO-based NFT’s
                        Secondary sellers can set their asking prices, and buyers can choose to pay the asking price or submit a bid.
                        Both sellers and buyers can see the entire transaction history of an asset to determine historical price appreciation quickly.
                    </p>
                </div>
                <div data-aos="zoom-in" data-aos-delay="200">
                    <span>+</span>
                    <h3>In-depth Reporting</h3>
                    <p>
                        The main dashboard gives sellers an in-depth overview of ticket sales and revenue. The data is broken down to show the percentage of tickets sold by event and ticket type, including primary and secondary sales. Sellers can also see each ticket's entire transaction history, including how many times it has been resold and for how much each time.
                    </p>
                </div>
            </div>
        </section>
    )
}

export default Features;
